'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Logo;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _colors = require('../styles/colors');

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import styles from './styles.scss';

function Logo(props) {
  var defaultStyles = (0, _styles2.default)(props.color, props.background);
  return _react2.default.createElement(
    'svg',
    {
      className: (0, _classnames2.default)(defaultStyles.toString()),
      viewBox: '0 0 550 120.89'
    },
    _react2.default.createElement(
      'title',
      null,
      'Tanda Logo'
    ),
    _react2.default.createElement('path', {
      d: 'M217.11,74H189.23a5.7,5.7,0,0,0-3.76,4.63l-6.77,80.93s0.09,5.58-3.84,5.58H155.61' + 's-3.87.05-3.19-5.28l7.1-80.57s0.61-5.21-4-5.21H128.2s-4.25.35-3.82-5.29l1.06-10.65s' + '-0.07-4.57,5.2-4.57h87.58s4.51,0.23,4.8,2.28l-0.87,14.26S221.57,73.81,217.11,74Zm95' + '.69,84.37s2.38,6.37-3,7H291.9s-4.3.13-5.56-4.89L281,142.72s-1.22-2.38-5.08-2.45H239' + '.66s-4.37-.06-6,3.6l-8.3,17.95s-1.48,3.41-6.5,3.54H202.41s-3.86-.26-3.15-3.41L250,5' + '7.85s1.39-3.5,4.74-3.77h20.33a5.15,5.15,0,0,1,4.57,3.15Zm-39.23-41.62-8.85-29.27c-0' + '.93-2.78-2.2-2.49-2.2-2.49A2.64,2.64,0,0,0,260,86.66L245.52,117.9c-1.33,3.76,2.49,4' + '.45,2.49,4.45h22C275.25,122.06,273.58,116.74,273.58,116.74Zm390.53,48.63H646.22s-4.' + '3.13-5.56-4.89l-5.38-17.75s-1.22-2.38-5.08-2.45H594s-4.37-.06-6,3.6l-8.3,17.95s-1.4' + '8,3.41-6.5,3.54H556.74s-3.86-.26-3.15-3.41L604.36,57.85s1.39-3.5,4.74-3.77h20.33A5.' + '15,5.15,0,0,1,634,57.22l33.13,101.13S669.51,164.72,664.11,165.37ZM627.9,116.74l-8.8' + '5-29.27c-0.93-2.78-2.2-2.49-2.2-2.49a2.64,2.64,0,0,0-2.49,1.68L599.84,117.9c-1.33,3' + '.76,2.49,4.45,2.49,4.45h22C629.58,122.06,627.9,116.74,627.9,116.74ZM327.84,161.23a3' + '.84,3.84,0,0,0,3.47,4H348a4.1,4.1,0,0,0,4-3.36l4.32-54.65-22-36.33ZM432.67,44.54H41' + '7.11c-4.86,0-4.86,4.86-4.86,4.86l-4.63,70.29a7.49,7.49,0,0,1-1.09,3.86,1.64,1.64,0,' + '0,1-1.47.59,6.71,6.71,0,0,1-2.82-2.54L364.4,58.89c-2.6-5.21-5.73-4.86-5.73-4.86H339' + '.76a3.28,3.28,0,0,0-3.07,1.5L400.5,161.29a8.26,8.26,0,0,0,4.28,3.7,7,7,0,0,0,1.56.3' + '5h18c4.69-.35,4.92-3.76,4.92-3.76L436.54,47.9C436.31,44.71,432.67,44.54,432.67,44.5' + '4Zm117.27,93.14S536.57,167,499.6,165.37H452.14s-4.51.26-4.08-5.82L454.7,58.11s0.09-' + '4.1,4.8-4.1h48.22s26.49-.74,40.09,17.29a65,65,0,0,1,5,8.5C556.42,88,563.12,109.42,5' + '49.93,137.68Zm-18.8-37.49a48.47,48.47,0,0,0-1-6c-5.52-20.15-27.23-19.94-27.23-19.94' + 'H485.6c-6.25.46-5.9,3.59-5.9,3.59l-3.82,61.32c-0.69,5.67,4.63,5.67,4.63,5.67H501c1.' + '85,0,7.29-.93,7.29-0.93C532.33,137.7,531.88,109.1,531.13,100.19Z',
      transform: 'translate(-124.35 -44.54)'
    })
  );
}

Logo.propTypes = {
  color: _propTypes2.default.oneOf([_colors.COLORS.WHITE, _colors.COLORS.BLUE]),
  background: _propTypes2.default.oneOf([_colors.COLORS.WHITE, _colors.COLORS.BLUE, ''])
};

Logo.defaultProps = {
  color: _colors.COLORS.BLUE,
  background: '' };


//////////////////
// WEBPACK FOOTER
// ./~/tanda-components/Logo/index.js
// module id = 685
// module chunks = 0